const Style = {
    loading: 'opacity-50',

    // Form action rows in the reference are right-aligned flex rows with
    // gap-2, not two 49%-wide floated blocks.
    button: 'min-w-[7rem]',
    buttonRow: 'mt-6 flex flex-wrap items-center justify-end gap-2',
};

export default Style;
